<script>
import { sync, call } from "vuex-pathify";

export default {
  name: "affiliate",
  computed: {
    quote: sync("quote"),
    results: sync("results"),
    parsedParams() {
      return JSON.parse(this.params)
    },
    referrer: sync("quote/referrer"),
  },
  methods: {
    updateQuote: call("quote/updateQuote"),
    clearQuote: call("quote/clearQuote"),
    load: call("results/getResults"),
    addToCart: call("cart/addToCart"),
  },
  data() {
    return {
      params: null,
      query: null,
      category: [
        'airportparking',
        'airporthotel',
        'airportlounge'
      ]
    }
  },
  mounted() {
    this.params = JSON.stringify(this.$route.params);
    this.query = JSON.stringify(this.$route.query);

    // check for params
    if(Object.keys(this.$route.params).length > 0) {

      this.clearQuote();
      let customParams = JSON.parse(this.query)['params[custom_id]'] ? [{ custom_id: JSON.parse(this.query)['params[custom_id]']}] : [];
      let quoteToSend = { ...this.parsedParams, params: customParams || null }

      // parse and push to store
      this.updateQuote({ affiliate: true, ...quoteToSend }).then(() => {

        // if the category is valid, push user to results page
        if(this.category.indexOf(this.quote.category) > -1) {

          this.load().then(() => {

            // search for product in response
            let product = this.results.products[this.parsedParams.category].find(p => {
              return p.product_id == this.parsedParams.product_id;
            })

            // if product is in response
            if(product) {

              // add the product to the cart
              this.addToCart({ category: this.parsedParams.category, ...product }).then(() => {

                // redirect the user to the payment page
                this.$router.replace('/payment', () => {});
              });

            } else {
              this.$router.replace(`/${this.parsedParams.category}-results`, () => {});
            }
          })
        }
      })
    }
  }
};
</script>

